"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importDefault(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
// Styles
const styles_1 = tslib_1.__importDefault(require("./styles"));
const ControlBarSection = (0, mobx_react_lite_1.observer)(({ children, classes = {} }) => {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "controlBarSection");
    return react_1.default.createElement("div", { className: mergedClasses.root }, children);
});
exports.default = ControlBarSection;
//# sourceMappingURL=index.js.map